import Vue from 'vue'
import App from './App.vue'
import  "./libraries/socket-client/sockjs.min";
import ElementUI from 'element-ui'
import './assets/style/element-variables.scss'
import Icon from 'vue-awesome/components/Icon'

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.component('icon', Icon);

new Vue({
  render: h => h(App),
}).$mount('#app')
